import React, { useEffect, useState } from "react";

const AddressForm = ({ formData, errors, handleChange, handleSubmit }) => {
  const [countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    try {
      const response = await fetch("/server/dealer_backend/global/country");
      const data = await response.json(); // Ensure you parse the JSON response
      if (data?.global_picklists.length > 0) {
        setCountries(data?.global_picklists[0]?.pick_list_values);
        console.log(data?.global_picklists[0]?.pick_list_values);
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      {formData.customerType === "endCustomer" && (
        <>
         <div>
            <label className="block mb-2 font-semibold">
              Company Name<span className="text-red-500">*</span>
            </label>
            <input
              name="CompName" // Changed to "Name"
              value={formData.CompName}
              onChange={handleChange}
              className={`border rounded-md ${
                errors.name ? "border-red-500" : "border-gray-300"
              } p-2 w-full`}
            />
            {errors.CompName && <p className="text-red-500">{errors.CompName}</p>}
          </div>
          <div>
            <label className="block mb-2 font-semibold">
              Customer Name<span className="text-red-500">*</span>
            </label>
            <input
              name="name" // Changed to "Name"
              value={formData.name}
              onChange={handleChange}
              className={`border rounded-md ${
                errors.name ? "border-red-500" : "border-gray-300"
              } p-2 w-full`}
            />
            {errors.name && <p className="text-red-500">{errors.name}</p>}
          </div>
          <div>
            <label className="block mb-2 font-semibold">
              Email<span className="text-red-500">*</span>
            </label>
            <input
              name="Email" // Changed to "Email"
              value={formData.Email}
              onChange={handleChange}
              className={`border rounded-md  ${
                errors.Email ? "border-red-500" : "border-gray-300"
              } p-2 w-full`}
            />
            {errors.Email && <p className="text-red-500">{errors.Email}</p>}
          </div>
          <div>
            <label className="block mb-2 font-semibold">Phone</label>
            <input
              name="Phone" // Changed to "Phone"
              value={formData.Phone}
              onChange={handleChange}
              className={`border rounded-md  ${
                errors.Phone ? "border-red-500" : "border-gray-300"
              } p-2 w-full`}
            />
            {errors.Phone && <p className="text-red-500">{errors.Phone}</p>}
          </div>
        </>
      )}

      <div>
        <label className="block mb-2 font-semibold">
          Address 1<span className="text-red-500">*</span>
        </label>
        <input
          name="Company_Name" // Changed to "Address_1"
          value={formData.Company_Name}
          onChange={handleChange}
          className={`border rounded-md ${
            errors.Company_Name ? "border-red-500" : "border-gray-300 "
          } p-2 w-full`}
        />
        {errors.Company_Name && (
          <p className="text-red-500">{errors.Company_Name}</p>
        )}
      </div>
      <div>
        <label className="block mb-2 font-semibold">Address 2</label>
        <input
          name="Address_2" // Changed to "Address_2"
          value={formData.Address_2}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
        {errors.Address_2 && <p className="text-red-500">{errors.Address_2}</p>}
      </div>
      <div>
        <label className="block mb-2 font-semibold">City</label>
        <input
          name="City" // Changed to "City"
          value={formData.City}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
        {errors.City && <p className="text-red-500">{errors.City}</p>}
      </div>
      <div>
        <label className="block mb-2 font-semibold">Postal Code</label>
        <input
          name="Postal_Code" // Changed to "Postal_Code"
          value={formData.Postal_Code}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
        {errors.Postal_Code && (
          <p className="text-red-500">{errors.Postal_Code}</p>
        )}
      </div>
      <div>
        <label className="block mb-2 font-semibold">State</label>
        <input
          name="State" // Added State input
          value={formData.State} // Assuming you have state in formData
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
        {errors.State && <p className="text-red-500">{errors.State}</p>}
      </div>
      {/* <div>
        <label className="block mb-2 font-semibold">Country</label>
        <input
          name="Country" // Changed to "Country"
          value={formData.Country}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
        {errors.Country && <p className="text-red-500">{errors.Country}</p>}
      </div> */}
      <div>
        <label className="block mb-2 font-semibold">Country<span className="text-red-500">*</span></label>
        <select
          name="Country"
          value={formData.Country}
          onChange={handleChange}
          className="border border-gray-300 rounded-md p-2 w-full"
        >
          <option value="">Select a country</option>
          {countries
            ?.filter((country) => country.display_value !== "-None-") // Filter out "-None-"
            .map((country) => (
              <option data-old-id={country.id} value={country.display_value}>
                {country.display_value}
              </option>
            ))}
        </select>
        {errors.Country && <p className="text-red-500">{errors.Country}</p>}
      </div>

      <div className="mt-4 flex items-center justify-center">
        <button
          type="submit"
          className="bg-blue-500 text-white p-2 rounded inline-block min-w-44"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default AddressForm;
